angular.module('app').config(packageContentsRouting);

function packageContentsRouting($routeProvider) {
  $routeProvider
    .when('/package_contents', {
      pageTitle: 'PACKAGES',
      template: '<package-contents-page></package-contents-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        // ajs: true,
      },
      menu: 'websites',
      accessPermission: 'index_package_accountadmin',
      authReq: true,
    })
    .when('/package_contents/new', {
      pageTitle: 'ADD_CONTENT',
      template: '<package-content-page></package-content-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        // ajs: true,
      },
      // breadcrumb: {
      //   label: 'PACKAGE',
      //   parent: 'package_contents',
      // },
      menu: 'websites',
      accessPermission: 'create_package_accountadmin',
      authReq: true,
    })
    .when('/package_contents/:id', {
      pageTitle: 'CONTENT_OVERVIEW',
      template: '<package-content-page></package-content-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        // ajs: true,
      },
      // breadcrumb: {
      //   label: 'PACKAGE',
      //   parent: 'package_contents',
      // },
      menu: 'websites',
      accessPermission: 'show_package_accountadmin',
      authReq: true,
    });
}

packageContentsRouting.$inject = ['$routeProvider'];
